import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Bekræft e-mailadresse',
  [OnboardingStep.StoreDetails]: 'Butiksoplysninger',
  [OnboardingStep.BusinessInfo]: 'Virksomhedsoplysninger',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Tilføj dine butiksoplysninger',
  [OnboardingStep.PersonalInfo]: 'Tilføj dine personlige oplysninger',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Ejerens personlige oplysninger',
  owner_personal_info_gmbh: 'Personlige oplysninger for ejer/direktør',
  [OnboardingStep.ShippingInfo]: 'Tilføj dine leveringsoplysninger',
  [OnboardingStep.BankInfo]: 'Tilføj bankoplysninger til udbetalinger',
  [OnboardingStep.TaxInfo]: 'Er din virksomhed momsregistreret?',
  [OnboardingStep.BusinessDocs]: 'Dokumentation for virksomhed',
  [OnboardingStep.PersonalDocs]: 'Dokumentation for identitet',
  [OnboardingStep.InfoSubmission]: 'Få udbetalt',
  confirm_info_gateway: 'Få udbetalt – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Betalingsoplysninger',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobilapp',
  [OnboardingStep.DeliveryStructure]: 'Leveringsstruktur',
  [OnboardingStep.Contract]: 'Kontrakt',
  [OnboardingStep.ContractPayment]: 'Kontraktbetaling',
  [OnboardingStep.Documents]: 'Upload dokumenter',
  [OnboardingStep.PromoCode]: 'Rabatkode',
};
